import React, { useCallback, useState } from 'react';
import { reduxForm }                    from 'redux-form';
import { useTranslation }               from 'react-i18next';
import { NavLink }                      from 'react-router-dom';

import useEventListener from '../../../../common/hooks/useEventListener';

import RenderButton            from '../../../components/buttons/base/RenderButton';
import { RenderCheckboxField } from '../../../components/fields/redux/RenderCheckboxField';
import { RenderDropZone }      from '../../../components/fields/redux/RenderDropZone';
import { RenderPhoneField }    from '../../../components/fields/redux/RenderPhoneField';
import { RenderTextArea }      from '../../../components/fields/redux/RenderTextArea';
import { RenderTextField }     from '../../../components/fields/redux/RenderTextField';
import DropZoneImageIcon       from '../../../components/icons/DropZoneImageIcon';
import DropZoneVideoIcon       from '../../../components/icons/DropZoneVideoIcon';
import { useCommon }           from '../../../providers/common';
import { useSidebar }          from '../../../providers/sidebar';
import sidebarConstants        from '../../../providers/sidebar/sidebar.constants';

import { validate } from './validate';

function GuaranteeForm({ ...props }) {
  const {
          form,
          handleSubmit,
          submitForm,
        }     = props;
  const { t } = useTranslation();

  const { pages }       = useCommon();
  const { showSidebar } = useSidebar();
  const [rows, setRows] = useState(8);

  const getPageUrl = useCallback((template) => {
    const page = pages.find(page => page.template === template);
    if (!page) {
      return '/';
    }

    return `/${page.urlKey}`;
  }, [pages]);

  const handleResize = useCallback(() => {
    if (typeof window !== 'undefined') {
      const { screen: { width } } = window;
      if (width <= 479) {
        setRows(23);
      } else {
        setRows(8);
      }
    }
  }, []);

  if (!isSSR()) {
    useEventListener('resize', handleResize);
  }

  return (
    <form
      name={form}
      className={form}
      noValidate={true}
      method={'post'}
      onSubmit={event => submitForm(event, handleSubmit)}
    >
      <fieldset>
        <legend>{t('client_orderInformation')}</legend>
        <div className={'order_details'}>
          <div className={'client_name'}>
            <RenderTextField
              autoComplete={'off'}
              name={'name'}
              placeholder={t('client_fullNameOfCustomer')}
              required
            />
          </div>
          <div className={'client_phone'}>
            <RenderPhoneField
              name={'phone'}
              placeholder={t('client_contactNumber')}
              required
            />
          </div>
          <div className={'client_order'}>
            <RenderTextField
              name={'order'}
              placeholder={t('client_numberOfOrder')}
            />
          </div>
        </div>
      </fieldset>
      <fieldset>
        <div className={'agreement'}>
          <RenderCheckboxField
            name={'agreeToTermsAndPrivacy'}
            label={<p>{t('client_agreement_guarantee.i_confirm')}{' '}
              <NavLink to={getPageUrl('policy-personal-data')}>{t('client_agreement_guarantee.user_agreement')}</NavLink>{' '}{t('client_agreement_guarantee.i_agree')}{' '}<NavLink
                to={getPageUrl('policy-personal-data')}
              >{t('client_agreement_guarantee.user_personal_data')}</NavLink>
            </p>}
          />
        </div>
      </fieldset>
      <fieldset>
        <legend>{t('field_comment')}</legend>
        <div className={'comment'}>
          <RenderTextArea
            name={'comment'}
            placeholder={t('client_descriptionOfProblem')}
            rows={rows}
          />
        </div>
      </fieldset>
      <div className={'dropzone_wrapper'}>
        <fieldset>
          <legend>{t('field_upload_photo')}</legend>
          <div>
            <RenderDropZone
              accept={'image/jpeg, image/png, image/gif, image/webp'}
              confines={t('client_problemFileSize')}
              dropDescription={t('drop_zone.move_photo')}
              fileSizeMb={6}
              icon={<DropZoneImageIcon />}
              maxFiles={6}
              multiple
              name={'images'}
              sizeDescription={t('drop_zone.photo_size')}
            />
          </div>
        </fieldset>
        <fieldset>
          <legend>{t('field_upload_video')}</legend>
          <div>
            <RenderDropZone
              accept={'video/mp4, video/mpeg, video/quicktime'}
              confines={t('client_problemFileSize')}
              dropDescription={t('drop_zone.move_video')}
              fileSizeMb={50}
              icon={<DropZoneVideoIcon />}
              maxFiles={6}
              multiple
              name={'video'}
              sizeDescription={t('drop_zone.video_size')}
            />
          </div>
        </fieldset>
      </div>
      <div className={'supporting_wrapper'}>
        <p>{t('client_check_order')}</p>
        <p>{t('client_required_fields')}</p>
      </div>
      <div className={'btns_wrapper'}>
        <RenderButton type={'submit'} className={'fill'} label={t('client_sendRequest')} />
        <RenderButton
          label={t('btn_get_advice')}
          action={() => showSidebar(sidebarConstants.CALL_ME_SIDEBAR, t('client_having_trouble'))}
        />
      </div>
    </form>
  );
}

export default reduxForm({
  form: 'GuaranteeForm',
  validate,
})(GuaranteeForm);